import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LinkOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"link_off"}/>
}
